import { ReactElement, ReactNode } from "react"

import ReactDOM from "react-dom"

import { MAIN_PORTAL_ID } from "@/constants"

interface IProps {
    withPortal?: boolean
    portalId?: string
    children?: ReactNode
}

const Portal = ({ withPortal = true, children, portalId = MAIN_PORTAL_ID }: IProps): ReactElement => {
    const domElement = document.getElementById(portalId)
    return withPortal ? ReactDOM.createPortal(children, domElement) : children ? <>{children}</> : null
}

export default Portal
